import { getProfile } from 'lib/api/auth'
import { useQuery } from 'react-query'

export function useProfile() {
  const query = useQuery('profile', getProfile)

  return query
}
